/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

module.exports = {
  /* 01.General */
  "general.copyright": "تمامی حقوق برای عکسچاپ محفوظ است © 2021",

  /* 02.User Login, Logout, Register */
  "user.login-title": "ورود",
  "user.register": "ثبت نام",
  "user.forgot-password": "فراموشی گذرواژ",
  "user.email": "پست الکترونیک",
  "user.password": "گذرواژه",
  "user.forgot-password-question": "فراموشی گذرواژه",
  "user.fullname": "نام کامل",
  "user.login-button": "ورود",
  "user.register-button": "ثبت نام",
  "user.reset-password-button": "بازنشانی",
  "user.buy": "خرید",
  "user.username": "نام کاربری",

  /* 03.Menu */
  "menu.app": "عکسچاپ تاپ",
  "menu.dashboards": "داشبورد ها",
  "menu.default": "پیش فرض",
  "menu.analytics": "تجزیه و تحلیل",
  "menu.ecommerce": "تجارت الکترونیک",
  "menu.content": "محتوا",
  "menu.pages": "صفحات",
  "menu.layouts": "طرح بندی ها",
  "menu.data-list": "لیست داده ها",
  "menu.thumb-list": "لیست بند انگشتی",
  "menu.image-list": "لیست تصویر",
  "menu.details": "جزئیات",
  "menu.search": "جستجو",
  "menu.login": "ورود",
  "menu.register": "ثبت نام",
  "menu.forgot-password": "فراموشی رمز عبور",
  "menu.error": "خطا",
  "menu.applications": "برنامه ها",
  "menu.todo": "لیست برای انجام کار",
  "menu.survey": "نظر سنجی",
  "menu.chat": "گفتگو",
  "menu.ui": "رابط کاربری",
  "menu.alerts": "هشدارها",
  "menu.badges": "مدال ها",
  "menu.buttons": "دکمه ها",
  "menu.cards": "کارت ها",
  "menu.carousel": "اسلایدر ها",
  "menu.charts": "نمودار ها",
  "menu.collapse": "باز و بسته شدن",
  "menu.dropdowns": "منوی باز شونده",
  "menu.editors": "ویرایشگرها",
  "menu.form-layouts": "طرح بندی فرم",
  "menu.form-components": "اجزای فرم",
  "menu.form-validations": "اعتبار سنجی فرم",
  "menu.icons": "آیکن ها",
  "menu.input-groups": "انواع Input Groups",
  "menu.jumbotron": "روزنامه",
  "menu.modal": "مودال",
  "menu.navigation": "ناوبری",
  "menu.popover-tooltip": "Popover & Tooltip",
  "menu.sortable": "قابل مرتب شدن",
  "menu.tables": "جداول",
  "menu.menu": "منو",
  "menu.subhidden": "زیرمنو پنهان",
  "menu.hidden": "پنهان",
  "menu.visible": "قابل رویت",
  "menu.maps":"نقشه ها",

  "menu.landingpage": "صفحه لندینگ",
  "menu.multipage-home": "خانه چندصفحه ای",
  "menu.singlepage-home": "خانه تک صفحه",
  "menu.about": "درباره",
  "menu.auth-login": "ورود خودکار",
  "menu.auth-register": "ثبت نام خودکار",
  "menu.blog": "بلاگ",
  "menu.blog-detail": "جزئیات بلاگ",
  "menu.careers": "مشاغل",
  "menu.confirmation": "تائیدیه",
  "menu.contact": "تماس",
  "menu.docs": "اسناد",
  "menu.features": "امکانات",
  "menu.prices": "قیمت ها",
  "menu.videos": "ویدئوها",
  "menu.mailing": "پست الکترونیکی",
  "menu.invoice": "صورتحساب",

  /* 04.Dashboards */
  "dashboards.pending-orders": "سفارشات در حال انتظار",
  "dashboards.completed-orders": "سفارشات تکمیل شده",
  "dashboards.refund-requests": "درخواست بازپرداخت",
  "dashboards.new-comments": "نظرات جدید",
  "dashboards.sales": "حراجی ها",
  "dashboards.orders": "سفارشات",
  "dashboards.refunds": "بازپرداخت",
  "dashboards.recent-orders": "سفارشات اخیر",
  "dashboards.product-categories": "دسته بندی محصولات",
  "dashboards.cakes": "کیک ها",
  "dashboards.tickets": "تیکت ها",
  "dashboards.calendar": "تقویم",
  "dashboards.best-sellers": "پرفروش ترین ها",
  "dashboards.website-visits": "بازدیدهای سایت",
  "dashboards.unique-visitors": "بازدید کنندگان منحصر به فرد",
  "dashboards.this-week": "این هفته",
  "dashboards.last-week": "هفته گذشته",
  "dashboards.this-month": "این ماه",
  "dashboards.conversion-rates": "نرخ تبدیل",
  "dashboards.per-session": "در طول جلسه",
  "dashboards.profile-status": "وضعیت پروفایل",
  "dashboards.payment-status": "وضعیت پرداخت",
  "dashboards.work-progress": "پیشرفت کار",
  "dashboards.tasks-completed": "وظایف تکمیل شده",
  "dashboards.payments-done": "پرداخت های انجام شده",
  "dashboards.order-stock": "سفارش - سهام",
  "dashboards.categories": "دسته بندی ها",
  "dashboards.quick-post": "پست سریع",
  "dashboards.title": "عنوان",
  "dashboards.content": "محتوا",
  "dashboards.category": "دسته بندی",
  "dashboards.save-and-publish": "ذخیره و انتشار",
  "dashboards.top-viewed-posts": "پست های پربازدید",
  "dashboards.posts": "پست ها",
  "dashboards.pending-for-publish": "انتظار برای انتشار",
  "dashboards.users": "کاربران",
  "dashboards.on-approval-process": "در روند تصویب",
  "dashboards.alerts": "هشدارها",
  "dashboards.waiting-for-notice": "در انتظار اطلاع",
  "dashboards.files": "فایل ها",
  "dashboards.pending-for-print": "انتظار برای چاپ",
  "dashboards.logs": "لاگ ها",
  "dashboards.gogo": "صبا",
  "dashboards.magic-is-in-the-details": "جادو در جزئیات است",
  "dashboards.yes-it-is-indeed": "بله، واقعا!",
  "dashboards.advanced-search": "جستجوی پیشرفته",
  "dashboards.toppings": "برترین ها",
  "dashboards.type": "تایپ کنید",
  "dashboards.keyword": "کلمه کلیدی",
  "dashboards.search": "جستجو",
  "dashboards.top-rated-items": "آیتم های محبوب",

  /* 05.Pages */
  "pages.add-new": "افزودن جدید",
  "pages.add-new-modal-title": "افزودن مورد جدید",
  "pages.display-options": "نمایش گزینه ها",
  "pages.orderby": "مرتب سازی بر اساس : ",
  "pages.product-name": "نام محصول",
  "pages.category": "دسته بندی",
  "pages.description": "توضیحات",
  "pages.status": "وضعیت",
  "pages.cancel": "لغو",
  "pages.submit": "ارسال",
  "pages.delete": "حذف",
  "pages.another-action": "اقدام دیگر",
  "pages.actions": "اقدامات",
  "pages.header": "هدر",
  "pages.details": "جزئیات",
  "pages.orders": "سفارشات",
  "pages.rating": "رتبه بندی",
  "pages.price": "قیمت",
  "pages.ingredients": "عناصر",
  "pages.is-vegan": "شامل تخفیف",
  "pages.order-status": "وضعیت سفارش",
  "pages.bake-progress": "وضعیت پردازش",
  "pages.popularity": "محبوبیت",
  "pages.comments": "نظرات",
  "pages.error-title": "ای وای ... به نظر می رسد خطایی رخ داده است!",
  "pages.error-code": "کد خطا",
  "pages.go-back-home": "بازگشت به صفحه اصلی",
  "pages.mailing-info":"قالب های ایمیل استفاده از یک ظاهر طراحی شده و طرح جدول را به خوبی در ارائه دهندگان خدمات نمایش داده می شود. برای ارائه قابلیت استفاده بهتر ما آن را به عنوان HTML معمولی با dangerouslySetInnerHTML قرار می دهیم.",
  "pages.invoice-info":"قالب صورتحساب دارای یک نسخه مدلسازی درون خطی برای استفاده در خارج از پروژه و نسخه React است.",
  "pages.react-version":"ورژن ری اکت",
  "pages.inline-version":"نسخه متنی سبک HTML",

  /* 06.Applications */

  /* 06.01.Chat */
  "chat.messages": "پیام ها",
  "chat.contacts": "مخاطبین",
  "chat.saysomething": "چیزی بگویید ...",


  /* 06.02.Survey */
  "survey.delete": "حذف",
  "survey.edit": "ویرایش",
  "survey.add-new": "افزودن جدید",
  "survey.add-new-title": "اضافه کردن نظرسنجی جدید",
  "survey.title": "عنوان",
  "survey.category": "دسته بندی",
  "survey.label": "برچسب",
  "survey.status": "وضعیت",
  "survey.cancel": "تغو",
  "survey.submit": "ارسال",
  "survey.another-action": "اقدام دیگر",
  "survey.display-options": "نمایش گزینه ها",
  "survey.orderby": "مرتب سازی بر اساس : ",
  "survey.all-surveys": "تمام نظرسنجی ها",
  "survey.completed-surveys": "نظرسنجی های کامل شده",
  "survey.categories": "دسته بندی ها",
  "survey.active-surveys": "نظر سنجی های فعال",
  "survey.labels": "برچسب ها",

  /* 06.03.Todo */
  "todo.add-new": "افزودن جدید",
  "todo.add-new-title": "افزودن جدید Todo",
  "todo.title": "عنوان",
  "todo.detail": "جزئیات",
  "todo.category": "دسته بندی",
  "todo.label": "برچسب",
  "todo.status": "وضعیت",
  "todo.cancel": "تغو",
  "todo.submit": "ارسال",
  "todo.action": "اقدام",
  "todo.another-action": "اقدام دیگر",
  "todo.display-options": "نمایش گزینه ها",
  "todo.orderby": "مرتب سازی بر اساس : ",
  "todo.all-tasks": "تمام وظایف",
  "todo.pending-tasks": "وظایف در انتظار",
  "todo.completed-tasks": "وضایف تکمیل شده",
  "todo.categories": "دسته بندی ها",
  "todo.labels": "برچسب ها",

  /* 07.UI */

  /* 07.01.Alerts */
  "alert.rounded": "هشدار گرد",
  "alert.react-notifications": "اطلاعیه های ری اکت",
  "alert.outline": "خط مرزی",
  "alert.primary": "اصلی",
  "alert.secondary": "ثانوی",
  "alert.info": "اطلاعات",
  "alert.success": "موفقیت",
  "alert.warning": "هشدار",
  "alert.error": "خطا",
  "alert.filled": "پر شده",
  "alert.primary-text": "این هشدار اولیه است و آن را چک کنید!",
  "alert.secondary-text": "این یک هشدار ثانویه است و آن را چک کنید!",
  "alert.success-text": "این هشدار موفقیت است و آن را بررسی کنید!",
  "alert.danger-text": "این یک هشدار خطر است - آن را چک کنید!",
  "alert.warning-text": "این یک هشدار warning است - آن را چک کنید!",
  "alert.info-text": "این یک هشدار اطلاعات است و آن را چک کنید!",
  "alert.light-text": "این هشدار نور است و آن را چک کنید!",
  "alert.dark-text": "این یک هشدار تاریک است و آن را چک کنید!",
  "alert.default": "هشدار پیشفرض",
  "alert.dismissing": "هشدار اخطار",
  "alert.dismissing-text":
    "کاربر گرامی، شما باید برخی از فیلد های زیر را بررسی کنید",
  "alert.dismissing-without-animate-text":
    "من یک هشدار بدون انیمیشن هستم!",

  /* 07.02.Badges */
  "badge.sizes": "سایز",
  "badge.colors": "رنگ ها",
  "badge.outline": "خط مرزی",
  "badge.links": "لینک ها",
  "badge.counter-badges": "مدال های شمارنده",
  "badge.bootstrap-default": "دیفالت بوتسترپ",
  "badge.primary": "اصلی",
  "badge.secondary": "ثانویه",
  "badge.success": "موفقیت",
  "badge.danger": "خطر",
  "badge.warning": "هشدار",
  "badge.info": "اطلاع",
  "badge.light": "روشن",
  "badge.dark": "تیره",

  /* 07.03.Buttons */
  "button.default": "بوتسترپ پیشفرض",
  "button.colors": "رنگ ها",
  "button.rounded": "گرد",
  "button.outline": "خط مرزی",
  "button.states": "وضعیت ها",
  "button.sizes": "سایز ها",
  "button.button-groups": "گروه دکمه",
  "button.large-button": "دکمه بزرگ",
  "button.small-button": "دکمه کوچک",
  "button.extra-small-button": "دکمه خیلی کوچک",
  "button.block-button": "دکمه بلوک",
  "button.active": "فعال",
  "button.disabled": "غیرفعال",
  "button.basic": "پایه",
  "button.toolbar": "نوار ابزار",
  "button.nesting": "Nesting",
  "button.vertical-variation": "تغییرات عمودی",
  "button.checkbox-radio-button": "چک باکس و رادیو باتن",
  "button.checkbox": "چک باکس",
  "button.radio": "رادیو",
  "button.radio-button": "رادیو باتن",
  "button.primary": "اصلی",
  "button.secondary": "ثانویه",
  "button.success": "موفقیت",
  "button.danger": "خطر",
  "button.warning": "هشدار",
  "button.info": "اطلاع",
  "button.light": "روشن",
  "button.dark": "تیره",
  "button.states-text":
    "این دکمه به مدت 2 ثانیه و یک آیکون خطا به مدت 3 ثانیه قبل از تعویض به وضعیت عادی نمایش داده می شود. این حالت ها را می توان با افزودن و حذف کلاس ها انجام داد.",
  "button.click-here": "اینجا را کلیک کنید",
  "button.states-text-alternate":
    "این دکمه به مدت 2 ثانیه و یک آیکون خطا به مدت 3 ثانیه قبل از تعویض به وضعیت عادی نمایش داده می شود. این حالت ها را می توان با افزودن و حذف کلاس ها انجام داد.",
  "button.primary-link": "لینک اصلی",
  "button.link": "لینک",
  "button.primary-button": "دکمه اصلی",
  "button.button": "دکمه",
  "button.left": "چپ",
  "button.middle": "وسط",
  "button.right": "راست",
  "button.dropdown": "بازشونده",
  "button.dropdown-link": "لینک بازشونده",

  /* 07.04.Cards */
  "cards.icon-card": "کارت آیکون",
  "cards.image-card": "عکس آیکون",
  "cards.image-overlay-card": "کارت پوشش تصویر",
  "cards.image-card-list": "فهرست کارت تصویر",
  "cards.tab-card": "کارت تب",
  "cards.user-card": "کارت کاربر",

  /* 07.05.Carousel */
  "carousel.basic": "Carousel پایه",
  "carousel.single": "Carousel تکی",
  "carousel.without-controls": "Carousel بدون کنترل",

  /* 07.06.Charts */
  "charts.line": "نمودار خطی",
  "charts.polar": "نمودار قطبی",
  "charts.area": "نمودار منطقه",
  "charts.scatter": "نمودار پراکندگی",
  "charts.bar": "نمودار میله ای",
  "charts.radar": "نمودار رادار",
  "charts.pie": "نمودار دایره ای",
  "charts.doughnut": "نمودار دونات",
  "charts.shadow": "سایه",
  "charts.no-shadow": "بدون سایه",

  /* 07.07.Collapse */
  "collapse.basic": "پایه",
  "collapse.toggle": "تغییر وضعیت",
  "collapse.accordion": "آکاردیون",
  "collapse.controlled": "کنترل شده",
  "collapse.uncontrolled": "بدون کنترل",

  /* 07.08.Dropdowns */
  "dropdowns.basic": "پایه",
  "dropdowns.controlled": "کنترل شده",
  "dropdowns.uncontrolled": "بدون کنترل",
  "dropdowns.dropdown": "بازشونده",
  "dropdowns.header": "هدر",
  "dropdowns.action": "اقدام",
  "dropdowns.another-action": "اقدام دیگر",
  "dropdowns.right": "راست",
  "dropdowns.left": "چپ",
  "dropdowns.drop-directions": "دستورالعمل Drop",
  "dropdowns.dropright": "باز شونده راست",
  "dropdowns.dropleft": "باز شونده چپ",
  "dropdowns.small-button": "دکمه کوچک",
  "dropdowns.large-button": "دکمه بزرگ",
  "dropdowns.sizing": "اندازه گیری",
  "dropdowns.split-button": "تقسیم دکمه Dropdowns",
  "dropdowns.dropup": "باز شونده بالا",

  /* 07.09.Editors */
  "editors.draftjs": "Draft.js",
  "editors.quill-standart": "کویل استاندارد",
  "editors.quill-bubble": "حباب کویل",

  /* 07.10.Forms */
  "forms.basic": "پایه",
  "forms.email": "پست الکترونیک",
  "forms.email-muted": "ما هرگز ایمیل شما را با دیگران به اشتراک نمیگذاریم.",
  "forms.password": "کلمه عبور",
  "forms.submit": "ارسال",
  "forms.horizontal": "افقی",
  "forms.radios": "رادیوها",
  "forms.first-radio": "رادیو اول",
  "forms.second-radio": "رادیو دوم",
  "forms.third-radio-disabled": "رادیو سوم غیرفعال",
  "forms.checkbox": "چک باکس",
  "forms.signin": "ورود",
  "forms.top-labels-over-line": "لیبل های بیش از خط",
  "forms.tags": "برچسب ها",
  "forms.date": "تاریخ",
  "forms.state": "وضعیت",
  "forms.top-labels-in-input": "لیبل های داخل Input",
  "forms.email-u": "پست الکترونیک",
  "forms.password-u": "کلمه عبور",
  "forms.tags-u": "برچسب ها",
  "forms.date-u": "تاریخ",
  "forms.state-u": "وضعیت",
  "forms.grid": "گرید فرم",
  "forms.address": "آدرس",
  "forms.address2": "آدرس 2",
  "forms.city": "شهر",
  "forms.city-message": "لطفا یک شهر انتخاب کنید!",
  "forms.state-message": "لطفا یک وضعیت انتخاب کنید!",
  "forms.zip": "فشرده",
  "forms.signup": "ثبت نام",
  "forms.inline": "خطی",
  "forms.validation-availity": "اعتبار سنجی واکنش پذیر",
  "forms.validation-formik": "اعتبارسنجی Formik",
  "forms.default": "Default",
  "forms.firstname": "نام",
  "forms.firstname-message": "لطفا نام خود را وارد کنید!",
  "forms.lastname": "نام خانوادگی",
  "forms.lastname-message": "لطفا نام خانوادگی خود را وارد کنید!",

  /* 07.11.Form Components */
  "form-components.custom-inputs": "Input های کاستوم",
  "form-components.checkboxes": "چک باکس ها",
  "form-components.radios": "رادیوها",
  "form-components.inline": "خطی",
  "form-components.react-select": "سلکت React",
  "form-components.state-single": "وضعیت تکی",
  "form-components.state-multiple": ".ضعیت چندانتخابی",
  "form-components.react-autosuggest": "پیشنهاد خودکار React",
  "form-components.date-picker": "انتخاب تاریخ",
  "form-components.date": "تاریخ",
  "form-components.date-range": "محدوده زمانی",
  "form-components.date-with-time": "تاریخ و زمان",
  "form-components.embedded": "جاسازی شده",
  "form-components.dropzone": "Dropzone",
  "form-components.drop-files-here": "فایل ها را در اینجا بکشید",
  "form-components.tags": "برچسب ها",
  "form-components.switch": "سوئیچ",
  "form-components.primary": "اصلی",
  "form-components.secondary": "ثانویه",
  "form-components.primary-inverse": "معکوس اولیه",
  "form-components.secondary-inverse": "معکوس ثانویه",
  "form-components.slider": "اسلایدر",
  "form-components.double-slider": "اسلایدر دوتایی",
  "form-components.single-slider": "اسلایدر تکی",
  "form-components.rating": "رتبه بندی",
  "form-components.interactive": "تعاملی",
  "form-components.readonly": "فقط خواندن",
  "form-components.type-a-cake": "چیزی تایپ کنید",
  "form-components.start": "شروع",
  "form-components.end": "پایان",
  "form-components.tables": "جدول ها",
  /* 07.12.Icons */
  "icons.simplelineicons": "آیکون خط ساده",
  "icons.iconsmind": "Iconsmind آیکن ها",

  /* 07.13.Input Groups */
  "input-groups.basic": "پایه",
  "input-groups.sizing": "اندازه گیری",
  "input-groups.small": "کوچک",
  "input-groups.default": "پیش فرض",
  "input-groups.large": "بزرگ",
  "input-groups.checkboxes-and-radios": "چک باکس ها و رادیو باتن ها",
  "input-groups.multiple-inputs": "Inputs چندگانه",
  "input-groups.first-and-last-name": "نام و نام خانوادگی",
  "input-groups.multiple-addons": "افزودنی های چندگانه",
  "input-groups.button-addons": "دکمه های چندگانه",
  "input-groups.button": "دکمه",
  "input-groups.buttons-with-dropdowns": "دکمه با منوی بازشونده",
  "input-groups.dropdown": "بازشونده",
  "input-groups.header": "هدر",
  "input-groups.action": "اقدام",
  "input-groups.another-action": "اقدام دیگر",
  "input-groups.custom-select": "Select سفارشی",
  "input-groups.options": "گزینه ها",
  "input-groups.choose": "انتخاب کنید...",
  "input-groups.custom-file-input": "File Input سفارشی",

  /* 07.14.Jumbotron */
  "jumbotron.hello-world": "سلام به همه..!",
  "jumbotron.lead":
    "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.",
  "jumbotron.lead-detail":
    "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.",
  "jumbotron.learn-more": "بیشتر بدانید",

  /* 07.15.Modal */
  "modal.basic": "پایه",
  "modal.modal-title": "عنوان مودال",
  "modal.launch-demo-modal": "راه اندازی و پیش نمایش مودال",
  "modal.scrolling-long-content": "اسکرول محتوای طولانی",
  "modal.backdrop": "پس زمینه",
  "modal.backdrop-value": "مقدار پس زمینه",
  "modal.right-modal": "مودال راست",
  "modal.launch-right-modal": "راه اندازی مودال راست",
  "modal.nested-modal": "مودال های تو در تو",
  "modal.size": "Size",
  "modal.launch-large-modal": "راه اندازی مودال بزرگ",
  "modal.launch-small-modal": "راه اندازی مودال کوچک",

  /* 07.16.Navigation */
  "nav.basic": "ناوبری اصلی",
  "nav.active": "فعال",
  "nav.disabled": "غیرفعال",
  "nav.disabled-link": "لینک غیرفعال",
  "nav.link": "لینک",
  "nav.longer-link": "لینک طولانی",
  "nav.another-link": "لینک دیگر",
  "nav.right": "راست",
  "nav.dropdown": "بازشونده",
  "nav.header": "هدر",
  "nav.action": "اقدام",
  "nav.another-action": "اقدام دیگر",
  "nav.horizontal-alignment": "منوی افقی",
  "nav.vertical-alignment": "منوی عمودی",
  "nav.pills": "Nav Pills",
  "nav.fill-justify": "منوی justify",
  "nav.pills-dropdowns": "Nav Pills با Dropdowns",
  "nav.pagination-basic": "صفحه بندی پایه",
  "nav.pagination-sizing": "سایزبندی صفحه بندی",
  "nav.large": "بزرگ",
  "nav.small": "کوچک",
  "nav.center": "وسط",
  "nav.pagination-alignment": "تراز بندی صفحه بندی",
  "nav.breadcrumb-basic": "مسیر سایت پایه",

  /* 07.17.Popover & Tooltip */
  "popover-tooltip.popover": "تولتیپ با کلیک",
  "popover-tooltip.tooltip": "تولتیپ",

  /* 07.18.Sortable */
  "sortable.columns": "ستون مرتب سازی",
  "sortable.basic": "پایه",
  "sortable.handles": "دستگیره ها",

  /* 07.19.Maps */
  "maps.google": "گوگل مپ",
  "maps.yandex": "یاندکس مپ",

  /* 07.20.Tables */
  "table.bootstrap-tables": "جدول های بوتسترپ",
  "table.bootstrap-basic": "جدول پایه",
  "table.bootstrap-striped": "سطر های راه راه",
  "table.bootstrap-bordered": "جدول حاشیه دار",
  "table.bootstrap-borderless": "جدول بدون حاشیه",
  "table.bootstrap-hoverable": "سطرهای قابل هاور شدن",
  "table.bootstrap-responsive": "جدول ریسپانسیو",
  "table.react-tables": "جدول React",
  "table.react-pagination": "صفحه بندی",
  "table.react-scrollable": "قابل مرتب سازی",
  "table.react-advanced": "فیلتر، طول و پرش",


  /* ORDERS */
  "menu.orders": "سفارش",
  "menu.new-order": "سفارش جدید",
  "orders.new.form.title":"فرم ثبت سفارش جدید",
  "orders.new.form.mobile":"موبایل مشتری",
  "orders.new.form.mobile.hint":"09123456789",
  "orders.new.form.customer-status":"وضعیت مشتری",
  "orders.new.form.save":"ثبت سفارش"
};



